<template>
  <div>
    <b-row class="arriba">
      <b-col class="col-title">
        <div class="title">
          <h4>{{ title }}</h4>
        </div>
      </b-col>

      <b-col>
        <div class="search">
          <!-- <Search /> -->
        </div>
      </b-col>
    </b-row>

    <div class="secciones">
      <Balance :datos="array[0] ? array[0] : []" />
    </div>

    <!-- <div class="nomina">
      <Nomina />
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatRole } from "../../../../components/tools/utils";
// import Search from "../../../../components/input/Search.vue";
import Balance from "./Balance.vue";
// import Nomina from "./Nomina.vue"
export default {
  components: {
    // Search,
    Balance
    // Nomina
  },
  data() {
    return {
      title: "Sus Procesos",
      array: []
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"])
  },
  methods: {
    mapServices: function() {
      if (!this.usuario) return;
      this.array = this.usuario.servicios.map(s => ({
        idUsuario: this.usuario.id,
        idServicio: s.id,
        ministerio: s.ministerio,
        perfil: formatRole(s.rolNombre),
        nombreServicio: s.nombre,
        usuarioServicioId: s.usuarioServicioId
      }));
    }
  },
  mounted() {
    this.mapServices();
  }
};
</script>

<style scoped>
.row {
  margin: 0;
}
.arriba {
  margin: 0 50px;
}

.title {
  margin-top: 60px;
  color: #24c6ab;
}

.search {
  text-align: end;
  margin-top: 60px;
}

.secciones {
  margin: 20px 0;
}

@media screen and (max-width: 1096px) {
  .col-title {
    margin-right: -200px;
  }
}

@media screen and (max-width: 734px) {
  .title {
    text-align: start;
  }
}

@media screen and (max-width: 436px) {
  .col-title {
    display: none;
  }
}
</style>
